import React, { useState, useEffect, Fragment } from "react";

import NumericInput from "react-numeric-input";

import { numberFormat } from "../repository";
import Global from "./Global";
import ProductApplications from "./ProductApplications";
import Modal360Viewer from "./Product360Viewer";
import ImageZoomViewer from "./ProductImageZoomViewer";

const ProductItem = (props) => {
  const [spinnerValue, setSpinerValue] = useState(1);
  const [imageSource, setImageSource] = useState("");
  const [is360, set360] = useState(false);
  const [isModal360Open, setIsModal360Open] = useState(false);
  const [isImageZoom, setIsImageZoom] = useState(false);
  const [codeSelected, setCodeSelected] = useState(null);
  //const [promocion] = useState(0);
  const index = props.index;
  const item = props.item;

  const onChangeValue = (e) => {
    setSpinerValue(e);
  };

  const onClick = (e) => {
    props.add(props.item, spinnerValue);
  };

  const openImageZoomModal = (e) => {
    e.preventDefault();
    if (imageSource !== Global.foto_nd) {
      setIsImageZoom(true);
    }
  };

  const closeImageZoomModal = () => {
    setIsImageZoom(false);
  };

  function openAppsModal(e) {
    e.preventDefault();
    setCodeSelected(item);
    //codeSelected.current = props.item;
  }

  const closeAppsModal = () => {
    setCodeSelected(null);
  };

  const open360Modal = (e) => {
    e.preventDefault();
    setIsModal360Open(true);
  };

  const close360Modal = () => {
    setIsModal360Open(false);
  };

  const checkImageExists = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  };

  useEffect(() => {
    let cancelled = false;

    const loadImages = async () => {
      const codigo = props.item.Codigo;
      const fotoUrl = Global.fotos_URL + codigo.toLowerCase().replace(/-/g, "_") + ".jpg";
      const foto360Url = Global.urlFotos360 + codigo.toUpperCase() + "/images/img_0_0_0.jpg";

      const [fotoExists, foto360Exists] = await Promise.all([
        checkImageExists(fotoUrl),
        checkImageExists(foto360Url),
      ]);

      if (!cancelled) {
        setImageSource(fotoExists ? fotoUrl : Global.foto_nd);
        set360(foto360Exists);
      }
    };

    loadImages();

    return () => { cancelled = true; };
  }, [props.item.Codigo, props.item.idMarcaProducto]);

  const renderInventory = () => {
    const inventario = props.inventario !== undefined ? props.inventario : -1;
    if (inventario === -1) return null;
    const lblInv = <small>Inventario:&nbsp;</small>;
    let badgeClass, label;
    if (inventario > 10) {
      badgeClass = "badge-success"; label = "Disponible";
    } else if (inventario > 0) {
      badgeClass = "badge-warning"; label = "Bajo (" + inventario + ")";
    } else {
      badgeClass = "badge-danger"; label = "No Disponible";
    }
    return (
      <span>
        {lblInv}
        <span className={"badge " + badgeClass}>{label}</span>
      </span>
    );
  };

  const renderPromocion = () => {
    return item.Promocion === 1 ? (
      <span className="badge badge-warning">* En Promoción *</span>
    ) : null;
  };
  const renderPrecioPromocion =()=>
  {
    return (
      <Fragment>
      { item.Promocion === 1 ? (
      
      <div className="col-xs text-right">
      <span className="badge badge-pill badge-light ">
        <del>${numberFormat(item.PrecioAnterior)}</del> 
      </span>&nbsp;
    </div> 
       
      ):("")
      }
    </Fragment>

    );
  
  }
  
  const estilo = '#FFDF95'

  const renderPromocional = () => {
    return item.Promocion === 1 ? estilo : "#00000008";
  };

  return (
    <div className="col-md-4 card-group">
      <div className="card mb-4 border-secondary">
        <div
          className="card-header text-center"
          style={{ backgroundColor: renderPromocional() }}
        >
          {props.item.Familia}
        </div>
        <img
          className="card-img-top"
          style={{
            cursor: "pointer",
            maxWidth: 100 + "%",
            height: 120 + "px",
            objectFit: "contain",
          }}
          src={imageSource}
          alt={props.item.Codigo}
          onClick={(e) => openImageZoomModal(e)}
          data-toggle="modal"
          data-target={"#modalImageZoom" + props.item.Codigo}
        />
        {isImageZoom && (
          <ImageZoomViewer
            item={props.item}
            imageSource={imageSource}
            closeModal={closeImageZoomModal}
          />
        )}
        {codeSelected && (
          <ProductApplications
            codigo={item.Codigo}
            closeModal={closeAppsModal}
          />
        )}
        <div className="card-body py-2 px-3">
          <div className="card-title mb-1">
            <div className="row align-items-center">
              <div className="col-xs ml-2">
                <h5 className="mb-0"><span className="badge badge-secondary">{item.Codigo}</span></h5>
              </div>
              <div className="col text-center">
                <button
                  className="btn btn-outline-warning btn-sm rounded-pill mr-1 py-0 px-2"
                  onClick={(e) => openAppsModal(e)}
                  data-toggle="modal"
                  data-target={"#modalApps" + item.Codigo}
                >
                  <small>APS</small>
                </button>
                {is360 && (
                  <button
                    type="button"
                    className="btn btn-outline-info btn-sm rounded-pill py-0 px-2"
                    onClick={(e) => open360Modal(e)}
                    data-toggle="modal"
                    value="360"
                    data-target={"#modal360" + item.Codigo + item.index}
                  >
                    <small>360</small>
                  </button>
                )}
                {isModal360Open && (
                  <Modal360Viewer
                    index={index}
                    item={item}
                    catalogo={true}
                    closeModal={close360Modal}
                  />
                )}
              </div>

                    {renderPrecioPromocion()}

              <div className="col-xs text-right mr-2">
                <h5 className="mb-0"><span className="badge badge-pill badge-primary">
                  ${numberFormat(item.PrecioPesosMayoreo)}
                </span></h5>
              </div>
            </div>
          </div>
          <div className="text-center mb-0">
            {renderInventory()}
            {renderPromocion() && <span className="ml-2">{renderPromocion()}</span>}
          </div>
        </div>

        {props.item.Descripcion ? (
          <div className="card-body card-text h-25">{item.Descripcion}</div>
        ) : (
          <ul className="list-group list-group-flush">
            <li className="list-group-item">
              <strong>Modelo : </strong>
              {item.Modelo}
            </li>
            <li className="list-group-item">
              <strong>Posición : </strong>
              {item.Posicion}
            </li>
            <li className="list-group-item">
              <strong>Condición : </strong>
              {item.Condicion}
            </li>
          </ul>
        )}

        <div
          className="card-footer text-center"
          style={{ backgroundColor: renderPromocional() }}
        >
          {item && (
            <table className="table-sm w-100">
              <tbody>
                <tr>
                  <td className="text-left">
                    <NumericInput
                      name="spinner"
                      min={1}
                      max={999}
                      value={spinnerValue}
                      size={7}
                      mobile={true}
                      className="btn-sm"
                      onChange={(value) => {
                        onChangeValue(value);
                      }}
                      maxLength={3}
                      style={{
                        "btnUp.mobile": {
                          width: "5.0ex",
                          bottom: 2,
                          boxShadow: "none",
                          borderRadius: 2,
                          borderWidth: 1,
                          backgroundColor: renderPromocional(),
                        },

                        "btnDown.mobile": {
                          width: "5.0ex",
                          bottom: 2,
                          left: 2,
                          top: 2,
                          right: "auto",
                          boxShadow: "none",
                          borderRadius: 2,
                          borderWidth: 1,
                          backgroundColor: renderPromocional(),
                        },
                      }}
                    />
                  </td>
                  <td className="text-right">
                    <button
                      className="btn btn-warning btn-block"
                      type="button"
                      onClick={() => onClick()}
                    >
                      <i className="fas fa-shopping-cart fa-sm"></i> <small>Agregar</small>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductItem;
